import { mockRestartDiscoveryAnalysisForUploadFinalize } from './discovery-intelligence-mock.handlers';

const UPLOAD_FINALIZE_PATH = /^\/api\/opportunities\/([^/]+)\/qualification\/upload\/finalize$/;
const WIZARD_STATE_PATH = /^\/api\/opportunities\/([^/]+)\/qualification\/wizard-state$/;

const wizardStateByOpportunityId = new Map<string, Record<string, unknown>>();

export function mockHandleQualificationWizardStateGet(canonical: string): {
  status: number;
  body: unknown;
} | null {
  const match = WIZARD_STATE_PATH.exec(canonical);
  if (!match?.[1]) {
    return null;
  }

  const opportunityId = decodeURIComponent(match[1]);
  const existing = wizardStateByOpportunityId.get(opportunityId);
  return {
    status: 200,
    body: existing ?? defaultWizardState(),
  };
}

export function mockHandleQualificationUploadFinalize(canonical: string): {
  status: number;
  body: unknown;
} | null {
  const match = UPLOAD_FINALIZE_PATH.exec(canonical);
  if (!match?.[1]) {
    return null;
  }

  const opportunityId = decodeURIComponent(match[1]);
  mockRestartDiscoveryAnalysisForUploadFinalize(opportunityId);
  markUploadFinalized(opportunityId);

  return {
    status: 200,
    body: { correlationId: `mock-upload-finalize-${opportunityId}` },
  };
}

export function mockMarkDiscoveryFinalized(opportunityId: string): void {
  const state = getOrCreateWizardState(opportunityId);
  state['discoveryAssessmentRunId'] = 'mock-discovery-run-completed';
  state['needsDiscoveryFinalize'] = false;
  state['needsScotsmanFinalize'] = true;
  wizardStateByOpportunityId.set(opportunityId, state);
}

function markUploadFinalized(opportunityId: string): void {
  const state = getOrCreateWizardState(opportunityId);
  state['uploadIndexedDocumentFingerprint'] = `mock-upload-${opportunityId}`;
  state['needsUploadFinalize'] = false;
  state['needsDiscoveryFinalize'] = true;
  wizardStateByOpportunityId.set(opportunityId, state);
}

function getOrCreateWizardState(opportunityId: string): Record<string, unknown> {
  return { ...defaultWizardState(), ...(wizardStateByOpportunityId.get(opportunityId) ?? {}) };
}

function defaultWizardState(): Record<string, unknown> {
  return {
    uploadIndexedDocumentFingerprint: null,
    discoveryAssessmentRunId: null,
    scotsmanDiscoveryRunId: null,
    scotsmanAnalyzerRunId: null,
    metadataFingerprint: null,
    bidRiskLastUpdatedAtUtc: null,
    needsUploadFinalize: true,
    needsDiscoveryFinalize: true,
    needsScotsmanFinalize: true,
    needsMetadataFinalize: true,
  };
}
